"use strict";

import { ItemListingState, ItemListingConfig, itemListingConfigModifier } from "./listing-helper";
import ListingCacheHandler from "./listing-cache-handler";
import ListingAnalyticsHelper from "./listing-analytics";
import ListingFilterHandler from "./listing-filter-handler";
import ItemListingListenersHandler from "./listing-listener-handler";
import ListingActionsHandler from "./listing-actions";
import Toolbox from "./toolbox";
import Mustache from "mustache";

class ListingClickHandler {

	constructor(customHandlers) {

		this.state = ItemListingState;
		this.config = ItemListingConfig;
		this.handlers = {};

		this.settings = {
			isMobile: false
		};
		this.handlers.cacheHandler = ListingCacheHandler;
		this.handlers.analyticsHelper = ListingAnalyticsHelper;
		this.handlers.filterHandler = ListingFilterHandler;
		this.handlers.listeners = ItemListingListenersHandler;
		this.handlers.actions = ListingActionsHandler;

		if (typeof customHandlers === "object" && customHandlers) {
			for (const key of Object.keys(customHandlers)) {
				this.handlers[key] = customHandlers[key];
			}
		}
	}

	checkboxClick() {

		const element = this.clickedElement;

		if (!element.classList.contains("component")) {
			const clickedCheckbox = Toolbox.closest(element, ".component-checkbox");
			if (clickedCheckbox) {

				// BD analytics start
				if (this.config.useCampaignAnalytics === true) {
					this.handlers.analyticsHelper.clickCheckboxAnalytics(clickedCheckbox);
				}
				// BD analytics end


				const currentCheckbox = document.querySelectorAll(".component.component-checkbox[data-id=\"" + clickedCheckbox.dataset.id + "\"]");
				const processCheckbox = (checkboxes, checkedOverride) => {
					for (const allfc of checkboxes) {
						let checked = true;
						if (checkedOverride !== undefined) {
							checked = checkedOverride;
							if (checkedOverride === true) {
								allfc.classList.add("checked");
							} else {
								allfc.classList.remove("checked");
							}
						} else {
							allfc.classList.toggle("checked");
							checked = allfc.classList.contains("checked") ? true : false;
						}

						allfc.dataset.value = checked ? 1 : 0;
						const ariaCheckbox = allfc.querySelector("[role=\"checkbox\"]");
						if (ariaCheckbox) {
							ariaCheckbox.setAttribute("aria-checked", checked ? "true" : "false");
						}
					}
				};

				processCheckbox(currentCheckbox);

				const checked = clickedCheckbox.classList.contains("checked") ? true : false;
				if (clickedCheckbox.dataset.filter === "select-group") {

					const groupCheckboxes = document.querySelectorAll(".option-group[data-group=\"" + clickedCheckbox.dataset.id + "\"] ul .component.component-checkbox");
					//viewRenderData[clickedAccordion.dataset.source];
					processCheckbox(groupCheckboxes, checked);
				}

				if (!this.settings.isMobile) {
					if (Toolbox.closest(element, ".bar-dropdown-view")) {
						this.handlers.filterHandler.saveViewState(this.handlers.filterHandler.getViewState());
					} else {
						//componentWait(function () { updateFilterState() });
					}
				} else {
					if (Toolbox.closest(element, ".component-accordion[data-type=\"accordion\"]")) {
						this.handlers.filterHandler.saveViewState(this.handlers.filterHandler.getViewState(true));

					} else {
						//componentWait(function () { updateFilterState() });
					}
				}
				return true;
			}
		}
		return false;
	}

	simpleAccordionClick() {
		const selector = ".component[data-type=simpleaccordion]";
		const element = this.clickedElement;
		const clickedAccordion = Toolbox.closest(element, selector);

		if (clickedAccordion) {


			this.handlers.actions.closeAccordions(clickedAccordion);

			if (!clickedAccordion.classList.contains("accordion-visible")) {

				// BD analytics start

				if (this.config.useCampaignAnalytics) {
					const label = clickedAccordion.querySelector(".component-label");
					this.handlers.analyticsHelper.openSearchAccordionEvent(label ? label.textContent : clickedAccordion.textContent);
				}
				// BD analytics end

				clickedAccordion.classList.add("accordion-visible");

				const viewWrap = clickedAccordion.querySelector(".view-wrapper");
				viewWrap.style.height = clickedAccordion.querySelector(".view-wrapper > *").offsetHeight + "px";
				Toolbox.waitForFinalEvent(() => {
					const heightFix = clickedAccordion.querySelector(".view-wrapper > *").offsetHeight;

					if (Toolbox.closest(viewWrap, ".component-accordion.accordion-visible")) {
						viewWrap.style.height = heightFix + "px";
					}
				}, 400, "accordionHeightFix");

				return true;
			} else if (clickedAccordion.classList.contains("accordion-visible")) {

				if (Toolbox.closest(element, ".view-wrapper")) {
					return false;
				}

				if (Toolbox.closest(element, selector)) {
					clickedAccordion.classList.remove("accordion-visible");
					clickedAccordion.querySelector(".view-wrapper").style.height = "";
				}
				return true;
			}
		}
		return false;
	}

	accordionClick() {
		const selector = ".component[data-type=accordion]";
		const element = this.clickedElement;
		const clickedAccordion = Toolbox.closest(element, selector);

		if (clickedAccordion) {
			this.handlers.actions.cleanHiddenViews();
			this.handlers.actions.closeAccordions(clickedAccordion);

			if (!clickedAccordion.classList.contains("accordion-visible")) {

				// BD analytics start

				if (this.config.useCampaignAnalytics) {
					const label = clickedAccordion.querySelector(".component-label");
					this.handlers.analyticsHelper.openSearchAccordionEvent(label ? label.textContent : clickedAccordion.textContent);
				}
				// BD analytics end

				clickedAccordion.classList.add("accordion-visible");

				const viewTemplate = document.querySelector("#" + clickedAccordion.dataset.view).textContent;
				Mustache.parse(viewTemplate);

				const dataObject = {
					class: "view-component",
					component: clickedAccordion.dataset.filter,
					items: this.handlers.cacheHandler.cache.viewRenderData[clickedAccordion.dataset.source]
				};

				if (clickedAccordion.dataset.options === "true") {
					dataObject.items = { filterValues: this.handlers.cacheHandler.cache.optionsLookup[clickedAccordion.dataset.source].values };
				} else {
					dataObject.items = this.handlers.cacheHandler.cache.viewRenderData[clickedAccordion.dataset.source];
				}

				const viewWrap = clickedAccordion.querySelector(".view-wrapper");
				viewWrap.innerHTML = Mustache.render(viewTemplate, dataObject);
				viewWrap.style.height = clickedAccordion.querySelector(".view-wrapper > *").offsetHeight + "px";
				this.handlers.filterHandler.restoreView(clickedAccordion);

				Toolbox.waitForFinalEvent(() => {
					const heightFix = clickedAccordion.querySelector(".view-wrapper > *").offsetHeight;

					if (Toolbox.closest(viewWrap, ".component-accordion.accordion-visible")) {
						viewWrap.style.height = heightFix + "px";
					}
				}, 400, "accordionHeightFix");

				return true;
			} else if (clickedAccordion.classList.contains("accordion-visible")) {

				if (Toolbox.closest(element, ".view-wrapper")) {
					return false;
				}

				if (Toolbox.closest(element, selector)) {
					clickedAccordion.classList.remove("accordion-visible");
					clickedAccordion.querySelector(".view-wrapper").style.height = "";
				}
				return true;
			}
		}
		return false;
	}

	fulldropdownClick() {
		const selector = ".component[data-type=\"fulldropdown\"]";
		const element = this.clickedElement;

		const filterBarDropdown = document.querySelector(".bar-dropdown-view");
		if (element.classList.contains("hit-area")) {
			const clickedDropdown = Toolbox.closest(element, selector);

			if (clickedDropdown) {

				// BD analytics start

				if (this.config.useCampaignAnalytics) {
					if (!clickedDropdown.classList.contains("dropdown-down")) {
						this.handlers.analyticsHelper.openSearchDropdown(clickedDropdown.textContent.trim());
					}
				}
				// BD analytics end

				this.handlers.actions.cleanHiddenViews();
				if (!clickedDropdown.classList.contains("dropdown-down")) {
					this.handlers.actions.resetDropDowns();
					this.handlers.listeners.addBlurListener(this.handlers.listeners.dropdownBlur);

					const clickedDropdowns = document.querySelectorAll(".component[data-type=\"fulldropdown\"][data-filter=\"" + clickedDropdown.dataset.filter + "\"]");

					for (const cdp of clickedDropdowns) {
						cdp.classList.add("dropdown-down");
					}
					filterBarDropdown.classList.add("dropdown-visible");

					const viewTemplate = document.querySelector("#" + clickedDropdown.dataset.view).textContent;
					filterBarDropdown.dataset.filter = clickedDropdown.dataset.filter;
					Mustache.parse(viewTemplate);

					const dataObject = {
						class: "view-component",
						component: clickedDropdown.dataset.filter,
						items: this.handlers.cacheHandler.cache.viewRenderData[clickedDropdown.dataset.source]
					};

					filterBarDropdown.innerHTML = Mustache.render(viewTemplate, dataObject);
					this.handlers.filterHandler.restoreView(clickedDropdown);
					this.handlers.actions.calculateBarDropdownHeight(filterBarDropdown);

					return true;
				} else if (clickedDropdown.classList.contains("dropdown-down")) {

					const cDropdowns = document.querySelectorAll(".component[data-type=\"fulldropdown\"][data-filter=\"" + clickedDropdown.dataset.filter + "\"]");

					for (const cdpw of cDropdowns) {
						cdpw.classList.remove("dropdown-down");
					}

					//clickedDropdown.classList.toggle("dropdown-down");
					filterBarDropdown.classList.remove("dropdown-visible");
					this.handlers.listeners.removeBlurListener(this.handlers.listeners.dropdownBlur);

					return true;
				}
			}
		}
		return false;
	}

	dropdownClick() {
		const selector = ".component[data-type=dropdown]";

		const template = document.querySelector("#cpl-dropdownTemplate").textContent;
		Mustache.parse(template);

		const clickedElement = this.clickedElement;

		if (clickedElement.classList.contains("hit-area")) {
			const clickedDropdownMenu = Toolbox.closest(clickedElement, selector);

			if (clickedDropdownMenu) {
				this.handlers.actions.cleanHiddenViews();
				if (!clickedDropdownMenu.classList.contains("dropdown-down")) {

					// BD analytics start

					if (this.config.useCampaignAnalytics) {
						const dropdownText = clickedDropdownMenu.querySelector(".component-label-mobile");
						this.handlers.analyticsHelper.openSearchDropdown(dropdownText ? dropdownText.textContent.trim() : clickedDropdownMenu.textContent.trim());
					}
					// BD analytics end

					this.handlers.actions.resetDropDowns();
					this.handlers.listeners.addBlurListener(this.handlers.listeners.dropdownBlur);

					clickedDropdownMenu.classList.toggle("dropdown-down");

					const rendered = Mustache.render(template, { options: this.state.dataSourceWorkset[clickedDropdownMenu.dataset.source] });
					const currentPopupDropdownMenu = clickedDropdownMenu.querySelector(".dropdown-menu");
					currentPopupDropdownMenu.innerHTML = rendered;
					const dropdownOption = currentPopupDropdownMenu.querySelector("[data-dropdown-option=\"" + clickedDropdownMenu.dataset.value + "\"]");

					if (dropdownOption) {
						dropdownOption.classList.add("selected");
					}

					return true;
				} else if (clickedDropdownMenu.classList.contains("dropdown-down")) {
					clickedDropdownMenu.classList.toggle("dropdown-down");
					this.handlers.listeners.removeBlurListener(this.handlers.listeners.dropdownBlur);
					return true;
				}
			}

		}

		if (clickedElement.dataset.dropdownOption) {

			const clickedPopupDropdownMenu = Toolbox.closest(clickedElement, selector);
			const sameDropdowns = document.querySelectorAll(".component.component-dropdown[data-filter=\"" + clickedPopupDropdownMenu.dataset.filter + "\"]");
			const popupMenuItem = clickedPopupDropdownMenu.querySelectorAll("[data-dropdown-option]");

			for (const mi of popupMenuItem) {
				mi.classList.remove("selected");
			}
			clickedElement.classList.add("selected");

			clickedPopupDropdownMenu.classList.remove("dropdown-down");

			// BD analytics start
			if (this.config.useCampaignAnalytics) {
				const dropdownText = clickedPopupDropdownMenu.querySelector(".component-label-mobile");
				this.handlers.analyticsHelper.selectFilterEvent(dropdownText ? dropdownText.textContent.trim() + ": " + clickedElement.textContent.trim() : clickedPopupDropdownMenu.textContent.trim());
			}
			// BD analytics end

			for (const sd of sameDropdowns) {
				sd.dataset.value = clickedElement.dataset.dropdownOption;
				sd.querySelector(".component-label").textContent = clickedElement.textContent;
			}
			this.handlers.listeners.removeBlurListener(this.handlers.listeners.dropdownBlur);
			//componentWait(function () { updateFilterState() });
			return true;
		}

		return false;

	}

	buttonClick() {
		const element = this.clickedElement;

		const selector = ".component[data-type=\"button\"], .component-lite[data-type=\"button\"]";
		const clickedButton = Toolbox.closest(element, selector);

		if (clickedButton) {
			this.handlers.actions[clickedButton.dataset.action]();
			return true;
		}

		return false;
	}

	processClick(e) {
		e.preventDefault();
		e.stopPropagation();
		//e.stopImmediatePropagation();
		this.clickedElement = e.target;

		let actionClicked = false;
		const checkAction = (action) => {
			if (actionClicked === false && action) {
				actionClicked = true;
			}
		};

		if (this.settings.isMobile) {
			checkAction(this.checkboxClick());
			checkAction(this.accordionClick());
			checkAction(this.simpleAccordionClick());
			checkAction(this.buttonClick());
		} else {
			checkAction(this.checkboxClick());
			checkAction(this.fulldropdownClick());
			checkAction(this.dropdownClick());
			checkAction(this.buttonClick());
		}

		return actionClicked;
	}

}

export default ListingClickHandler;